export const SkillsData=
[

    {
        type:"",
        list:[
            {
                name:"Python",
                icon: <i class="devicon-python-plain colored"></i>,
            },
            {
                name:"Javascript",
                icon:<i class="devicon-javascript-plain colored"></i>,
            },
            {
                name:"Java",
                icon: <i class="devicon-java-plain"></i>,
            },
            {
                name:"React JS",
                icon:<i class="devicon-react-original colored"></i>,
            },
            {
                name:"Next JS",
                icon:<i class="devicon-nextjs-original-wordmark colored"></i>,
            },
            {
                name:"WordPress",
                icon:<i class="devicon-wordpress-plain colored"></i>,
            },
            {
                name:"Node JS",
                icon:<i class="devicon-nodejs-plain colored"></i>,
            },
            {
                name:"Express JS",
                icon: <i class="devicon-express-original colored"></i>,
            },
            {
                name:"Django",
                icon:<i class="devicon-django-plain-wordmark colored"></i>
            },
            {
                name:"Shell Scripting (Bash)",
                icon: <i class="devicon-bash-plain colored"></i>,
            },
            {
                name:"MongoDB",
                icon:<i class="devicon-mongodb-plain colored"></i>,
            },
            {
                name:"MySQL",
                icon:<i class="devicon-mysql-plain-wordmark colored"></i>
            },
        ]
    },
]
